export default __webpack_public_path__ + "static/media/account-domain-settings-crx-featured.89b6a92c.svg";